<template>
  <div class="container" v-if="show">
    <div class="logo"></div>
    <div class="tit"></div>
    <div class="form_box">
      <van-form @submit="onSubmit">
        <van-field
          v-model="form_arr.acc"
          name="acc"
          label="账 号："
          label-width="auto"
          placeholder="请填写裁判账号"
          class="input_box"
          label-class="input_left"
          :rules="[{ required: true, message: '请填写裁判账号' }]"
        />
        <van-field
          v-model="form_arr.pass"
          type="password"
          name="pass"
          label="密 码："
          label-width="auto"
          placeholder="请填写裁判账号的密码"
          class="input_box"
          label-class="input_left"
          :rules="[{ required: true, message: '请填写裁判账号的密码' }]"
        />
        <div style="margin: .29rem;">
          <van-button round block type="info" native-type="submit" color="#952112" class="btn_sub"><span style="color: #fbca67;">登 录</span></van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
let that,token;
import {Toast, Form, Field, Button, Popup, Picker} from 'vant';
export default {
  name: "Home",
  components:{
    'van-form':Form,
    'van-field':Field,
    'van-button':Button,
    'van-popup':Popup,
    'van-picker':Picker,
  },
  data(){
    return{
      show:false,
      team:'',
      form_arr:{
        acc:'',
        pass:'',
      },
      showPicker:false,
      sub_status:true,
    }
  },
  created() {
    that=this;
    /*if(this.$route.query.is_test){
      this.isOpen=true;
    }*/
    token=localStorage.getItem('token');
    if(token){
      this.getData();
    }else{
      this.show=true;
    }
  },
  methods:{
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    onSubmit(values) {
      // console.log('submit', values);
      this.sub();
    },
    onConfirm(value,index) {
      this.team = value;
      this.form_arr.team = index+1;
      this.showPicker = false;
    },
    sub(){
      if(!this.sub_status){
        return false;
      }
      this.sub_status=false;
      this.$http(this.$Global.api_base+'login.php',this.form_arr,'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        that.sub_status=true;
        if(res.status==1){
          if(res.token){
            localStorage.setItem('token',res.token);
            that.token=res.token;
            that.show=false;
            that.isLogin=true;
            switch(parseInt(res.role_id)){
              case 1:that.$router.push('/index.html');break;
              case 2:that.$router.push('/obstacle.html');break;
              case 3:that.$router.push('/finish.html');break;
              case 4:that.$router.push('/end.html');break;
              case 5:that.$router.push('/start.html');break;
              case 6:that.$router.push('/time.html');break;
            }
          }else{
            Toast('登录失败，请重试');
          }
        }else{
          Toast(res.info);
        }
      }).catch(function (error) {
        console.log(error);
        /*Toast(error);*/
      });
    },
    getData() {
      this.$http(that.$Global.api_base+'checkLogin.php',{},'POST').then(function (response) {
        /*console.log(response)*/
        var res=response.data;
        if(res.status==1){
          switch(parseInt(res.role_id)){
            case 1:that.$router.push('/index.html');break;
            case 2:that.$router.push('/obstacle.html');break;
            case 3:that.$router.push('/finish.html');break;
            case 4:that.$router.push('/end.html');break;
            case 5:that.$router.push('/start.html');break;
          }
        }
      }).catch(function (error) {
        console.log(error);
      })
    },
  }
}
</script>

<style scoped>
.container{
  width: 100%;
  min-height: 13.24rem;
  height: 100%;
  position: relative;
  flex-shrink: 0;
  overflow-y: auto;
}
.logo{
  width: 5.71rem;
  height: .58rem;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 5vh;
  background: var(--home_logo) no-repeat;
  background-size: 100% auto;
}
.tit{
  width: 6.68rem;
  height: .96rem;
  position: relative;
  background: var(--home_tit) no-repeat;
  background-size: 100% auto;
  flex-shrink: 0;
  margin: 12vh auto 0;
}
  .form_box{
    position: absolute;
    top: 6.05rem;
    left: 1rem;
    width: 5.4rem;
    min-height: 1rem;
  }
  .input_box{
    margin-bottom: 1.3rem;
    border-radius: .32rem;
    font-size: .38rem;
  }
  .btn_sub{
    font-size: .48rem;
    color: #952112;
  }
</style>
<style>
  .input_left{
    width: 1.1rem;
    color: #952112;
    font-weight: bold;
    font-size: .38rem;
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue